// extracted by mini-css-extract-plugin
export default {"colorClass":"DoctorAppointmentSummary_colorClass__ULiDW"};